

import styled from "styled-components";

export const StyledChat = styled.div`
    padding: 10px;
    border-bottom: 2px solid white;
    font-size: 15px;
    background: #F2F5F8;

    .message-data {
        margin-bottom: 15px;
    }

    .message-data-time {
        color: #92959E;
        padding-left: 6px;
    }

    .message {
        color: white;
        padding: 5px 8px;
        font-size: 15px;
        border-radius: 7px;
        margin-bottom: 15px;
        width: 100%;
        position: relative;

        &:after {
            bottom: 100%;
            left: 7%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-bottom-color: #86BB71;
            border-width: 10px;
            margin-left: -10px;
        }
    }

    .my-message {
        background: #86BB71;
    }

    .text-right {
        textarea {
            text-align: right !important;
        }
    }

    .text-left {
        // background: #86BB71 !important;
        textarea {
            text-align: left !important;
        }

        &: after {
            color: #86BB71 !important;
            left: 3% !important;
        }

        .message-data-name {
            float: left !important;
        }

        .other-message.my-message {
            background: #86BB71 !important;
        }
    }

    .other-message {
        background: #0096fb;

        &: after {
            border-bottom-color: #94C2ED;
            left: 93%;
        }

        textarea {
            border: none;
            color: #fff;
        }

        .mentioned {
            font-weigth: bold !important;
        }
    }


    .other-message:after{
        border-bottom-color: #0096fb;
        left: 93%;
    }



    .chat-message {
        padding: 9px 0px;

        textarea {
            width: 100%;
            border: none;
            padding: 10px 20px;
            font: 14px/22px "Lato", Arial, sans-serif;
            margin-bottom: 10px;
            border-radius: 5px;
            resize: none;

        }
    }
`;
